/**
 * Displays a vertical list of skeleton rows for loading placeholders.
 * @param count - number of skeleton rows to render (default is 3).
 */
interface SkeletonRowProps {
  count?: number;
}

export const SkeletonRow = ({ count = 3 }: SkeletonRowProps) => {
  return (
    <div className="space-y-2 w-full">
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="flex items-center py-3 space-x-4 w-full animate-pulse first:pt-0 last:pb-0"
        >
          <div className="w-1/3 h-4 rounded bg-muted-foreground/15"></div>
          <div className="flex-1 h-4 rounded bg-muted-foreground/15"></div>
        </div>
      ))}
    </div>
  );
};
